/* ============================================================
   NORTHERN RAISED PDP - shared behaviour for all nr- sections
   - Scoped to section roots via data attributes (no global ids)
   - Re-initializes on shopify:section:load for the theme editor
   - Adds to cart via /cart/add.js and hands rendering to the
     theme's own cart drawer (Dawn/Crave architecture), with
     graceful fallbacks.
   ============================================================ */
(function () {
  "use strict";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function escHtml(t) { return String(t == null ? "" : t).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function moneyFactory(currency) {
    var f;
    try { f = new Intl.NumberFormat("en-CA", { style: "currency", currency: currency || "CAD" }); }
    catch (e) { f = null; }
    return function (cents) { return f ? f.format(cents / 100) : "$" + (cents / 100).toFixed(2); };
  }

  /* ---------- Cart: hand off to the theme drawer ---------- */
  function addToCart(items) {
    var body = { items: items };
    var drawer = document.querySelector("cart-drawer");
    var notification = document.querySelector("cart-notification");
    var target = null;
    if (drawer && typeof drawer.getSectionsToRender === "function") { target = drawer; }
    else if (notification && typeof notification.getSectionsToRender === "function") { target = notification; }
    if (target) {
      try {
        body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      } catch (e) { /* proceed without sections */ }
    }
    return fetch(routesRoot + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) { throw data; }
        if (target && data.sections && typeof target.renderContents === "function") {
          target.renderContents(data);
          if (target.classList && target.classList.contains("is-empty")) { target.classList.remove("is-empty"); }
        } else {
          refreshCartCount();
        }
        document.dispatchEvent(new CustomEvent("nr:cart:added", { detail: data }));
        return data;
      });
    });
  }
  function refreshCartCount() {
    fetch(routesRoot + "cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$(".cart-count-bubble span[aria-hidden], .cart-count-bubble span:not(.visually-hidden)").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      }).catch(function () {});
  }

  /* ---------- Main product / buy box ---------- */
  function initBuyBox(root) {
    var box = root.hasAttribute && root.hasAttribute("data-nr-buybox") ? root : $("[data-nr-buybox]", root);
    if (!box || box.dataset.nrInit) return;
    box.dataset.nrInit = "1";

    var cfgEl = $("[data-nr-product-json]", box);
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var money = moneyFactory(box.dataset.currency);
    var weightLb = parseFloat(box.dataset.weightLb) || 0;
    var mealsSetting = parseFloat(box.dataset.meals) || 0;
    var meals = mealsSetting > 0 ? mealsSetting : (weightLb > 0 ? Math.max(1, Math.round(weightLb * 1.3)) : 0);
    var grocery = (box.dataset.grocery || "").trim();
    var qtyMax = parseInt(box.dataset.qtyMax, 10); if (isNaN(qtyMax) || qtyMax < 1) qtyMax = 10;

    var S = {
      variant: cfg.variants[0] || null,
      planId: null,
      qty: 1,
      bump: false
    };

    var els = {
      price: $("[data-nr-price]", box),
      compare: $("[data-nr-compare]", box),
      save: $("[data-nr-save]", box),
      perlb: $("[data-nr-perlb]", box),
      atc: $("[data-nr-atc]", box),
      atcLabel: $("[data-nr-atc-label]", box),
      atcError: $("[data-nr-atc-error]", box),
      qtyOut: $("[data-nr-qty-out]", box),
      freq: $("[data-nr-freq]", box),
      stickyPrice: $("[data-nr-sticky-price]", box),
      countdown: $("[data-nr-countdown]", box),
      subPrice: $("[data-nr-sub-price]", box),
      vselect: $("[data-nr-variant-select]", box)
    };

    function planNum(name) { var m = /^\s*(\d+)/.exec(name || ""); return m ? parseInt(m[1], 10) : Number.MAX_SAFE_INTEGER; }
    function planLabel(p, basePrice) {
      var name = String(p.name || "");
      var m = /^\s*(\d+)\s*week/i.exec(name);
      var label = m ? m[1] + " week" + (parseInt(m[1], 10) > 1 ? "s" : "") : name.replace(/\s*subscription.*$/i, "");
      if (basePrice && p.price < basePrice) {
        var pct = Math.round((1 - p.price / basePrice) * 100);
        if (pct > 0) label += " (save " + pct + "%)";
      }
      return label;
    }
    function rebuildFreq() {
      if (!els.freq || !S.variant) return;
      var seen = {};
      var plans = S.variant.plans.filter(function (p) {
        if (seen[p.name]) return false; seen[p.name] = 1; return true;
      }).sort(function (a, b) {
        var d = planNum(a.name) - planNum(b.name);
        return d !== 0 ? d : String(a.name).localeCompare(String(b.name));
      });
      var cur = els.freq.value;
      var base = S.variant ? S.variant.price : 0;
      els.freq.innerHTML = plans.map(function (p) {
        return '<option value="' + p.id + '">' + escHtml(planLabel(p, base)) + "</option>";
      }).join("");
      var stillThere = plans.some(function (p) { return String(p.id) === String(cur); });
      if (stillThere) els.freq.value = cur;
      if (S.planId) S.planId = els.freq.value || null;
    }
    function planFor(id) {
      if (!S.variant || !id) return null;
      for (var i = 0; i < S.variant.plans.length; i++) { if (String(S.variant.plans[i].id) === String(id)) return S.variant.plans[i]; }
      return null;
    }
    function unit() {
      var p = planFor(S.planId);
      return p ? p.price : (S.variant ? S.variant.price : 0);
    }
    function compareUnit() {
      var p = planFor(S.planId);
      var base = S.variant ? S.variant.compare : 0;
      return p ? Math.max(p.compare, base) : base;
    }
    var bumpPool = $$("[data-nr-bump]", box);
    var activeBump = null;
    if (bumpPool.length) {
      var bpick = bumpPool.length > 1 ? Math.floor(Math.random() * bumpPool.length) : 0;
      bumpPool.forEach(function (b, i) { b.hidden = i !== bpick; });
      activeBump = bumpPool[bpick];
    }
    function bumpData() {
      if (!activeBump) return null;
      return { id: parseInt(activeBump.dataset.variantId, 10), price: parseInt(activeBump.dataset.price, 10), compare: parseInt(activeBump.dataset.compare, 10) };
    }
    function render() {
      if (!S.variant) return;
      var u = unit();
      var cu = compareUnit();
      var bd = S.bump ? bumpData() : null;
      var subtotal = u * S.qty + (bd ? bd.price : 0);
      var compareTotal = cu * S.qty + (bd ? bd.compare : 0);
      if (els.price) els.price.textContent = money(u);
      if (els.compare) { els.compare.textContent = money(cu); els.compare.style.display = cu > u ? "" : "none"; }
      if (els.save) {
        if (compareTotal > subtotal) { els.save.style.display = ""; els.save.textContent = "You save " + money(compareTotal - subtotal).replace(".00", ""); }
        else { els.save.style.display = "none"; }
      }
      if (els.perlb) {
        var parts = [];
        if (weightLb > 0) parts.push("<b>" + money(Math.round(u / weightLb)).replace(/\.00(\D|$)/, "$1") + "/lb</b>");
        if (meals > 0) parts.push("about <b>" + money(Math.round(u / meals)) + " per family dinner</b>");
        var txt = parts.join(", ");
        if (txt && grocery) txt += ". Grocery equivalents run $" + grocery + "+/lb\u2020.";
        else if (txt) txt += ".";
        els.perlb.innerHTML = txt;
        els.perlb.style.display = txt ? "" : "none";
      }
      if (els.subPrice && S.variant.plans.length) {
        var showId = S.planId || (els.freq && els.freq.value);
        var sp = planFor(showId) || S.variant.plans[0];
        if (sp) {
          els.subPrice.innerHTML = (sp.price < S.variant.price ? "<s>" + money(S.variant.price) + "</s>" : "") + money(sp.price);
        }
      }
      var verb = S.planId ? "Subscribe now" : "Add to cart";
      if (els.atcLabel) els.atcLabel.textContent = verb + " \u00B7 " + money(subtotal);
      if (els.stickyPrice) els.stickyPrice.textContent = money(subtotal);
      if (els.atc) {
        var ok = S.variant.available;
        els.atc.disabled = !ok;
        if (!ok && els.atcLabel) els.atcLabel.textContent = "Sold out";
      }
    }

    /* plans */
    $$("[data-nr-plan]", box).forEach(function (card) {
      card.addEventListener("click", function () {
        $$("[data-nr-plan]", box).forEach(function (c) { c.classList.toggle("nr-on", c === card); });
        var input = card.querySelector("input"); if (input) input.checked = true;
        var pid = card.dataset.planId || "";
        if (pid === "sub" || pid === "") {
          S.planId = pid === "sub" ? (els.freq ? els.freq.value : null) : null;
        } else {
          S.planId = pid;
        }
        render();
      });
    });
    if (els.freq) {
      els.freq.addEventListener("change", function () {
        if (S.planId) { S.planId = els.freq.value; render(); }
      });
    }

    /* variant select (only rendered when product has 2+ variants) */
    if (els.vselect) {
      els.vselect.addEventListener("change", function () {
        var id = els.vselect.value;
        for (var i = 0; i < cfg.variants.length; i++) {
          if (String(cfg.variants[i].id) === String(id)) { S.variant = cfg.variants[i]; break; }
        }
        rebuildFreq();
        if (S.planId && !planFor(S.planId)) S.planId = els.freq ? els.freq.value || null : null;
        render();
      });
    }

    /* qty */
    var plus = $("[data-nr-qty-plus]", box), minus = $("[data-nr-qty-minus]", box);
    if (plus) plus.addEventListener("click", function () { S.qty = Math.min(qtyMax, S.qty + 1); if (els.qtyOut) els.qtyOut.textContent = S.qty; render(); });
    if (minus) minus.addEventListener("click", function () { S.qty = Math.max(1, S.qty - 1); if (els.qtyOut) els.qtyOut.textContent = S.qty; render(); });

    /* bump */
    bumpPool.forEach(function (bumpEl) {
      bumpEl.addEventListener("click", function (e) {
        e.preventDefault();
        S.bump = !S.bump;
        bumpEl.classList.toggle("nr-on", S.bump);
        var input = bumpEl.querySelector("input"); if (input) input.checked = S.bump;
        render();
      });
    });

    /* add to cart */
    function showError(msg) {
      if (!els.atcError) return;
      els.atcError.textContent = msg || "Something went wrong. Please try again.";
      els.atcError.classList.add("nr-on");
      setTimeout(function () { els.atcError.classList.remove("nr-on"); }, 5000);
    }
    function doAdd(btn) {
      if (!S.variant || !S.variant.available) return;
      var items = [{ id: S.variant.id, quantity: S.qty }];
      if (S.planId) items[0].selling_plan = parseInt(S.planId, 10);
      var bd = S.bump ? bumpData() : null;
      if (bd && bd.id) items.push({ id: bd.id, quantity: 1 });
      var prev = els.atcLabel ? els.atcLabel.textContent : "";
      if (els.atc) els.atc.disabled = true;
      addToCart(items).then(function () {
        if (els.atc) { els.atc.classList.add("nr-added"); els.atc.disabled = false; }
        if (els.atcLabel) els.atcLabel.textContent = "Added to your box \u2713";
        setTimeout(function () { if (els.atc) els.atc.classList.remove("nr-added"); render(); }, 1600);
      }).catch(function (err) {
        if (els.atc) els.atc.disabled = false;
        if (els.atcLabel) els.atcLabel.textContent = prev;
        showError(err && (err.description || err.message));
      });
    }
    $$("[data-nr-atc-trigger]", box).forEach(function (b) { b.addEventListener("click", function () { doAdd(b); }); });

    /* evergreen countdown to 11:59pm Eastern, every day */
    function easternNow() {
      try { return new Date(new Date().toLocaleString("en-US", { timeZone: "America/Toronto" })); }
      catch (e) { return new Date(); }
    }
    function tick() {
      if (!els.countdown) return;
      var n = easternNow();
      var end = new Date(n); end.setHours(23, 59, 59, 999);
      var ms = Math.max(0, end - n);
      var h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      var prefix = box.dataset.countdownPrefix || "Order by";
      els.countdown.textContent = prefix + " " + h + "h " + m + "m";
    }
    tick();
    setInterval(tick, 3e4);

    /* gallery */
    var slides = $$("[data-nr-slide]", box), thumbs = $$("[data-nr-thumb]", box);
    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        slides.forEach(function (s, k) { s.classList.toggle("nr-on", k === i); });
        thumbs.forEach(function (th, k) { th.classList.toggle("nr-on", k === i); });
      });
    });

    /* sticky mobile bar */
    var stickyBar = $("[data-nr-sticky]", box);
    if (stickyBar && "IntersectionObserver" in window) {
      var buyCol = $("[data-nr-buycol]", box) || box;
      new IntersectionObserver(function (es) {
        var e = es[0];
        stickyBar.classList.toggle("nr-show", !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(buyCol);
    }

    rebuildFreq();
    render();
  }

  /* ---------- Trace section + farm stage ---------- */
  function initTrace(root) {
    var section = root.hasAttribute && root.hasAttribute("data-nr-trace") ? root : $("[data-nr-trace]", root);
    if (!section || section.dataset.nrInit) return;
    section.dataset.nrInit = "1";

    var grid = $("[data-nr-trace-steps]", section);
    var path = $("[data-nr-trace-path]", section);
    var steps = $$("[data-nr-step]", section);
    var stage = $("[data-nr-stage]", section);
    var cap = $("[data-nr-stage-cap]", section);
    if (!grid || !path || !steps.length) return;

    var hoverScene = 0;
    function setScene(n) {
      if (!stage) return;
      n = Math.min(4, Math.max(1, n));
      if (stage.getAttribute("data-scene") !== String(n)) {
        stage.setAttribute("data-scene", n);
        var step = steps[n - 1];
        if (cap && step && step.dataset.caption) cap.textContent = step.dataset.caption;
      }
    }
    function traceScroll() {
      var mid = window.innerHeight * 0.55;
      var r = grid.getBoundingClientRect();
      var p = r.height > 0 ? Math.min(1, Math.max(0, (mid - r.top) / r.height)) : 0;
      path.style.strokeDashoffset = reduced ? 0 : (1 - p);
      var idx = 1;
      steps.forEach(function (s, i) {
        var sr = s.getBoundingClientRect();
        var on = reduced || (sr.top + sr.height * 0.5) <= mid;
        s.classList.toggle("nr-lit", on);
        if (on) idx = i + 1;
      });
      if (!hoverScene) setScene(idx);
    }
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(function () { traceScroll(); ticking = false; }); ticking = true; }
    }, { passive: true });
    window.addEventListener("resize", traceScroll);
    steps.forEach(function (s, i) {
      s.addEventListener("mouseenter", function () { hoverScene = i + 1; setScene(hoverScene); });
      s.addEventListener("mouseleave", function () { hoverScene = 0; traceScroll(); });
    });
    if (stage && !reduced) {
      var pA = $(".nr-plx-a", stage), pB = $(".nr-plx-b", stage), plx = false;
      stage.addEventListener("mousemove", function (e) {
        if (plx) return; plx = true;
        requestAnimationFrame(function () {
          var r = stage.getBoundingClientRect();
          var dx = (e.clientX - r.left) / r.width - 0.5;
          if (pA) pA.style.transform = "translateX(" + (dx * 16).toFixed(1) + "px)";
          if (pB) pB.style.transform = "translateX(" + (dx * -12).toFixed(1) + "px)";
          plx = false;
        });
      });
      stage.addEventListener("mouseleave", function () {
        if (pA) pA.style.transform = ""; if (pB) pB.style.transform = "";
      });
    }
    traceScroll();
  }

  /* ---------- Cross-sell quick add ---------- */
  function initQuickAdd(root) {
    $$("[data-nr-quick-add]", root).forEach(function (b) {
      if (b.dataset.nrInit) return;
      b.dataset.nrInit = "1";
      b.addEventListener("click", function () {
        var id = parseInt(b.dataset.variantId, 10);
        if (!id) return;
        var prev = b.textContent;
        b.disabled = true;
        addToCart([{ id: id, quantity: 1 }]).then(function () {
          b.textContent = "Added \u2713"; b.disabled = false;
          setTimeout(function () { b.textContent = prev; }, 1600);
        }).catch(function () { b.textContent = prev; b.disabled = false; });
      });
    });
  }

  /* ---------- Live Loox reviews (Storefront API) ---------- */
  function initLoox(root) {
    $$("[data-nr-loox-api]", root).forEach(function (el) {
      if (el.dataset.nrInit) return;
      el.dataset.nrInit = "1";
      var store = el.dataset.storeId, pid = el.dataset.productId;
      var section = el.closest(".nr-reviews") || document;
      var status = $("[data-nr-loox-status]", section);
      if (!store || !pid) return;
      var url = "https://storefront-api.loox.io/storefront/v1/store/" + encodeURIComponent(store) + "/product-reviews?product_id=" + encodeURIComponent(pid);
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      }).then(function (data) {
        var list = data.reviews || data.data || data.items || (Array.isArray(data) ? data : []);
        if (!Array.isArray(list) || !list.length) {
          if (status) status.textContent = "No reviews yet for this product.";
          return;
        }
        var sum = 0, hist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, rated = 0;
        list.forEach(function (r) {
          var v = parseInt(r.rating || r.stars, 10);
          if (v >= 1 && v <= 5) { sum += v; hist[v]++; rated++; }
        });
        var cards = list.slice(0, 12).map(function (r) {
          var v = Math.min(5, Math.max(1, parseInt(r.rating || r.stars, 10) || 5));
          var stars = "";
          for (var i = 0; i < 5; i++) stars += i < v ? "\u2605" : '<span style="opacity:.28">\u2605</span>';
          var title = escHtml(r.title || r.headline || "");
          var body = escHtml(r.body || r.content || r.text || r.review || "");
          var who = escHtml((r.reviewer && (r.reviewer.name || r.reviewer.first_name)) || r.name || r.author || "Verified buyer");
          var date = escHtml(String(r.created_at || r.createdAt || r.date || "").slice(0, 10));
          var photo = "";
          var p = (r.photos && r.photos[0]) || (r.images && r.images[0]) || r.photo || r.image;
          if (p) { var pu = typeof p === "string" ? p : (p.url || p.src || ""); if (pu) photo = '<div class="nr-rev-photo"><img src="' + escHtml(pu) + '" loading="lazy" alt="Customer photo"></div>'; }
          return '<article class="nr-rev-card"><span class="nr-s">' + stars + "</span>" +
            (title ? '<h3 class="nr-h4">' + title + "</h3>" : "") + photo +
            (body ? "<p>" + body + "</p>" : "") +
            '<div class="nr-who">' + who + ' <span class="nr-vb">\u2713 Verified buyer</span>' + (date ? " \u00B7 " + date : "") + "</div></article>";
        });
        el.innerHTML = cards.join("");
        var avgEl = $("[data-nr-rev-avg]", section);
        if (avgEl && rated) avgEl.textContent = (sum / rated).toFixed(1);
        var cntEl = $("[data-nr-rev-count]", section);
        if (cntEl) cntEl.textContent = list.length + " reviews via Loox";
        for (var s2 = 1; s2 <= 5; s2++) {
          var pct = rated ? Math.round(hist[s2] / rated * 100) : 0;
          var bar = $('[data-nr-hist="' + s2 + '"]', section);
          if (bar) bar.style.width = pct + "%";
          var lbl = $('[data-nr-histpct="' + s2 + '"]', section);
          if (lbl) lbl.textContent = pct + "%";
        }
        if (status) status.textContent = "Reviews collected from verified buyers through Loox.";
      }).catch(function () {
        if (status) status.textContent = "Reviews couldn't load right now.";
      });
    });
  }

  /* ---------- Cross-sell: randomize collection candidates per pageview ---------- */
  function initXsellRandom(root) {
    $$("[data-nr-xsell-random]", root).forEach(function (grid) {
      if (grid.dataset.nrInit) return;
      grid.dataset.nrInit = "1";
      var n = parseInt(grid.dataset.count, 10) || 3;
      var cards = $$("[data-nr-x-candidate]", grid);
      if (cards.length <= n) { cards.forEach(function (c) { c.hidden = false; }); return; }
      var idx = cards.map(function (_, i) { return i; });
      for (var i = idx.length - 1; i > 0; i--) {
        var k = Math.floor(Math.random() * (i + 1));
        var tmp = idx[i]; idx[i] = idx[k]; idx[k] = tmp;
      }
      cards.forEach(function (c) { c.hidden = true; });
      for (var m = 0; m < n; m++) {
        var c = cards[idx[m]];
        c.hidden = false;
        grid.appendChild(c);
      }
    });
  }

  /* ---------- Cross-sell carousel arrows ---------- */
  function initXsellNav(root) {
    $$("[data-nr-x-nav]", root).forEach(function (nav) {
      if (nav.dataset.nrInit) return;
      nav.dataset.nrInit = "1";
      var section = nav.closest(".nr-xsell");
      var track = section ? $(".nr-x-track", section) : null;
      if (!track) { nav.style.display = "none"; return; }
      function step() {
        var card = track.querySelector(".nr-x-card:not([hidden])");
        return card ? card.offsetWidth + 18 : 300;
      }
      var prev = $("[data-nr-x-prev]", nav), next = $("[data-nr-x-next]", nav);
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    });
  }

  /* ---------- Scroll reveals ---------- */
  var revealIO = null;
  function initReveals(root) {
    var els = $$("[data-nr-reveal]", root);
    if (!els.length) return;
    if (reduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("nr-in"); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("nr-in"); revealIO.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    }
    els.forEach(function (el) { if (!el.classList.contains("nr-in")) revealIO.observe(el); });
  }

  /* ---------- Boot ---------- */
  function initAll(root) {
    initBuyBox(root);
    initTrace(root);
    initXsellRandom(root);
    initXsellNav(root);
    initQuickAdd(root);
    initLoox(root);
    initReveals(root);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
